import { SC_SPRITE, type ScIconId } from './chrome-sprite';

// The site chrome's icon sprite (chrome-sprite.ts, generated from the design export),
// mounted once by the app shell, and the one-line icon that draws a symbol from it.
export function ChromeSprite() {
  return <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true" dangerouslySetInnerHTML={{ __html: SC_SPRITE }} />;
}

export function ScIcon({ id, className }: { id: ScIconId; className?: string }) {
  return (
    <svg className={className ? `sc-ic ${className}` : 'sc-ic'} aria-hidden="true" focusable="false">
      <use href={`#${id}`} />
    </svg>
  );
}
